var React = require('react');

function IconM (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0h210.16L369.6 278.77 535.6 0h208.93v430.91c0 109.85-40.44 199.07-166.34 199.07h-5.47V262.44L369.6 572.71 171.82 266.24v363.74c-129 0-171.82-89-171.82-198.85z"}));
}

IconM.displayName = "IconM";

IconM.defaultProps = {"viewBox":"0 0 744.53 629.98"};

module.exports = IconM;

IconM.default = IconM;
